const state = {
  userLimit: [],
  menuList: '',
  height: 0,
  oldUserSeeAmount: true,
  searchParams: {},
  searchParamDialog: {},
  areaList: []
};

export default state;



// WEBPACK FOOTER //
// ./src/store/store.js